import { apiSlice } from '../../../../app/apiSlice';
import { Vereador, VereadorDTO, VereadorList } from '../../../../typesSite/vereador/Vereador';
import configSiteUrls from '../../configs/configSiteUrls';

const endpointUrl = configSiteUrls.SITE_VEREADOR_EP;

function getVereadores({ search }: { search: string }) {
  return {
    url: `${endpointUrl}/filter?search=${search}`,
    method: 'GET'
  };
}

function addVereador(obj: VereadorDTO) {
  return {
    url: `${endpointUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function deleteVereador({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}
function getVereador(id: string) {
  if (!id) {
    return {
      url: '',
      method: ''
    };
  }

  return {
    url: `${endpointUrl}/${id}`,
    method: 'GET'
  };
}
/** */

export const VereadorApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getVereadores: query<VereadorList[], { search: string }>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getVereadores,
      providesTags: ['Vereador']
    }),

    getVereador: query<Vereador, string>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getVereador,
      providesTags: ['Vereador']
    }),
    addVereador: mutation<void, Vereador>({
      query: addVereador,
      invalidatesTags: ['Vereador']
    }),
    deleteVereador: mutation<void, { id: string }>({
      query: deleteVereador,
      invalidatesTags: ['Vereador']
    })
  })
});
export const { useGetVereadoresQuery, useGetVereadorQuery, useAddVereadorMutation, useDeleteVereadorMutation } = VereadorApiSlice;
